import { apply, put, select, all, call } from 'redux-saga/effects';
import {
  onLoadChecklistItemGroupsSucceeded,
  onLoadChecklistItemGroupSucceeded,
  loadSingleChecklistItemSucceeded,
  loadSingleChecklistItemFailed,
  onLoadChecklistItemsForChecklist,
  onLoadChecklistItemsForChecklistSucceeded,
} from '../reducers/checklistItemGroup.reducers';

import {
  errorNotification,
  successNotification,
} from '../reducers/notification.reducers';

export function* loadChecklistItemGroups(checklistItemGroupApi, { payload }) {
  const response = yield apply(
    checklistItemGroupApi,
    checklistItemGroupApi.loadChecklistItemGroups,
    [payload.id]
  );
  if (response.errorCode) {
    yield put(errorNotification('Fehler beim Laden der ChecklistItemGroups'));
  } else {
    yield put(
      onLoadChecklistItemGroupsSucceeded({ checklistItemGroups: response })
    );
    yield put(onLoadChecklistItemsForChecklist(payload));
  }
}

export function* loadChecklistItemsForChecklist(
  checklistItemGroupApi,
  { payload }
) {
  const response = yield apply(
    checklistItemGroupApi,
    checklistItemGroupApi.loadChecklistItemsForChecklist,
    [payload.id]
  );
  if (response.errorCode) {
    yield put(errorNotification('Fehler beim Laden der ChecklistItemGroups'));
  } else {
    yield put(
      onLoadChecklistItemsForChecklistSucceeded({ checklistItems: response })
    );
  }
}

export function* loadAllChecklistItemGroupChecklistItems(
  checklistItemGroupApi,
  { payload }
) {
  try {
    const response = yield apply(
      checklistItemGroupApi,
      checklistItemGroupApi.loadChecklistItemGroupChecklistItems,
      [payload.id]
    );

    if (response.error) {
      yield put(errorNotification('Fehler beim Abrufen der Fragen'));
    } else {
      yield put(
        onLoadChecklistItemGroupSucceeded({
          checklistItems: response,
          checklistItemGroup: payload,
        })
      );
    }
  } catch (e) {
    yield put(errorNotification('Fehler beim Abrufen der Fragen'));
  }
}

export function* loadChecklistItemGroupChecklistItems(
  checklistItemGroupApi,
  { payload }
) {
  try {
    yield loadChecklistItemGroups(checklistItemGroupApi);

    const checklistRuns = yield select(
      (state) => state.checklists.checklistRuns
    );
    const openRun = checklistRuns.find((t) => t.checklistId == payload.id);
    let response = null;
    if (openRun) {
      response = yield apply(
        checklistItemGroupApi,
        checklistItemGroupApi.loadChecklistRunChecklistItemsV2,
        [openRun.id]
      );
    } else {
      response = yield apply(
        checklistItemGroupApi,
        checklistItemGroupApi.loadChecklistItemGroupChecklistItems,
        [payload.id]
      );
    }

    // const response = yield apply(
    //   checklistItemGroupApi,
    //   checklistItemGroupApi.loadChecklistItemGroupChecklistItems, [payload.id]);

    if (response.error) {
      yield put(errorNotification('Fehler beim Abrufen der Fragen'));
    } else {
      yield put(
        onLoadChecklistItemGroupSucceeded({
          checklistItems: response,
          checklistItemGroup: payload,
        })
      );
    }
  } catch (e) {
    yield put(errorNotification('Fehler beim Abrufen der Fragen'));
  }
}

export function* loadChecklistItemById(checklistItemGroupApi, { payload }) {
  try {
    const response = yield apply(
      checklistItemGroupApi,
      checklistItemGroupApi.loadChecklistItem,
      [payload]
    );

    if (response.errorCode || !response) {
      yield put(loadSingleChecklistItemFailed());
    } else {
      yield put(loadSingleChecklistItemSucceeded(response));
    }
  } catch (e) {
    yield put(
      loadSingleChecklistItemFailed({
        message: 'Fehler beim Laden des Kärtchens',
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/sagas/checklistItemGroup.sagas.js